import clsx from 'clsx';
import { useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import history from '../helpers/history';
import Page from '../layout/components/Page';

const BidsPage = () => {
  const { menu } = useParams<{ menu: string }>();
  const { pathname } = useLocation<{ pathname: string }>();

  const makeActive = (path: string) => {
    const splitLocation = pathname.split('/');

    console.log(splitLocation);

    if (splitLocation[2]) {
      return splitLocation[2] === path ? 'active' : 'false';
    }
    return '';
  };

  useEffect(() => {
    if (!menu) {
      history.push('/bids/all');
    }
  }, [menu]);

  return (
    <Page title='Bids' icon='bi-tags'>
      <div className='card'>
        <div className='card-body'>
          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              <li className='nav-item'>
                <Link className={clsx('nav-link text-active-primary me-6', makeActive('all'))} to='/bids/all'>
                  All
                </Link>
              </li>
              <li className='nav-item'>
                <Link className={clsx('nav-link text-active-primary me-6', makeActive('pending'))} to='/bids/pending'>
                  Pending
                </Link>
              </li>
              <li className='nav-item'>
                <Link className={clsx('nav-link text-active-primary me-6', makeActive('active'))} to='/bids/active'>
                  Active
                </Link>
              </li>
              <li className='nav-item'>
                <Link className={clsx('nav-link text-active-primary me-6', makeActive('closed'))} to='/bids/closed'>
                  Closed
                </Link>
              </li>
            </ul>
          </div>

          <div className='w-100 pt-10 pb-10'>
            <div className='table-responsive'>
              <table className='table table-bordered table-hover align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bolder text-muted bg-light'>
                    <th className='ps-4 min-w-285px rounded-start'></th>
                    <th className='min-w-100px'>Category</th>
                    <th className='min-w-70px'>Budget</th>
                    <th className='min-w-70px'>Proposal</th>
                    <th className='min-w-100px'>Status</th>
                    <th className='text-end rounded-end'></th>
                  </tr>
                </thead>

                <tbody>
                  {[1, 2, 3, 4, 5].map((item) => (
                    <tr key={item}>
                      <td>
                        <div className='d-flex align-items-center'>
                          <div className='d-flex justify-content-start flex-column'>
                            <Link to='#' className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                              Inspect Property Building
                            </Link>
                            <div>
                              <span className='text-muted fw-bold text-muted d-block fs-7'>
                                <i className='bi bi-person'></i> Investor John
                              </span>
                            </div>
                            <div className='mt-2'>
                              <span className='text-muted fw-bold text-muted d-block fs-7'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard...</span>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className='align-top'>
                        <span className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>Lawyers</span>
                      </td>
                      <td className='align-top'>
                        <span className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>$200</span>
                      </td>
                      <td className='align-top'>
                        <span className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>$180</span>
                      </td>
                      <td className='align-top'>
                        <span className='badge badge-light-warning fs-7 fw-bold'>pending</span>
                      </td>
                      <td className='text-end align-top'>
                        <Link to='#' className='btn  btn-primary btn-sm me-1 fw-bold'>
                          view
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default BidsPage;
